<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span>“Apri gli occhi e riguarda qual son io.”</span></p>
<p class="fm1"><span>“II Paradiso” (xxiii, 46),</span></p>
<p class="fm1"><span><i>Dante’s Commedia</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?d8c4ed68